"use client";

/**
 * global-error.tsx — boundary global Next.js (root level).
 *
 * Suprime warning do `@sentry/nextjs` na build ("missing global-error file"):
 * captura erros de root via `Sentry.captureException` antes de exibir UI
 * de fallback amigavel em PT-BR.
 *
 * Next.js convencao: este arquivo so e renderizado quando layout root explode.
 */
import * as Sentry from "@sentry/nextjs";
import { useEffect } from "react";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="pt-BR">
      <body
        style={{
          margin: 0,
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
          background: "#f8fafc",
          color: "#0f172a",
          padding: "2rem",
        }}
      >
        <div
          style={{
            maxWidth: "32rem",
            width: "100%",
            background: "#ffffff",
            border: "1px solid #e2e8f0",
            borderRadius: "0",
            padding: "2rem",
            boxShadow: "0 1px 2px rgba(0,0,0,0.04)",
          }}
        >
          <h1
            style={{
              fontSize: "1.25rem",
              fontWeight: 600,
              marginBottom: "0.5rem",
            }}
          >
            Não foi possível carregar o GOVIO
          </h1>
          <p
            style={{
              fontSize: "0.875rem",
              color: "#475569",
              lineHeight: 1.6,
              marginBottom: "1.5rem",
            }}
          >
            Encontramos um erro inesperado. Você pode tentar novamente ou voltar ao painel. Se o erro
            continuar, entre em contato com o suporte do GOVIO.
          </p>
          {error.digest ? (
            <p
              style={{
                fontSize: "0.75rem",
                fontFamily: "ui-monospace, SFMono-Regular, monospace",
                color: "#94a3b8",
                marginBottom: "1.5rem",
              }}
            >
              Codigo do incidente: {error.digest}
            </p>
          ) : null}
          <div style={{ display: "flex", gap: "0.5rem" }}>
            <button
              type="button"
              onClick={() => reset()}
              style={{
                background: "#0f172a",
                color: "#ffffff",
                border: "none",
                padding: "0.5rem 1rem",
                borderRadius: "0.375rem",
                fontSize: "0.875rem",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              Tentar novamente
            </button>
            <a
              href="/dashboard"
              style={{
                background: "#ffffff",
                color: "#0f172a",
                border: "1px solid #e2e8f0",
                padding: "0.5rem 1rem",
                borderRadius: "0.375rem",
                fontSize: "0.875rem",
                fontWeight: 500,
                textDecoration: "none",
                display: "inline-flex",
                alignItems: "center",
              }}
            >
              Voltar ao painel
            </a>
          </div>
        </div>
      </body>
    </html>
  );
}
